import { ref } from 'vue'

export const isDemo = ref()
export const demoCourseLessonId = ref()
